<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }"
          >党建专栏</el-breadcrumb-item
        >
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>深刻领会党的二十大的主题！- -论深入学习贯彻党的二十大精神</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2022-10-28</span></p>
        <p>“高举中国特色社会主义伟大旗帜，全面贯彻新时代中国特色社会主义思想，弘扬伟大建党精神，自信自强、守正创新，踔厉奋发、勇毅前行，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。”党的二十大的主题是大会的灵魂，是党和国家事业发展的总纲，也是我们学习宣传贯彻党的二十大精神必须深刻领会的重要内容。</p>
        <p>旗帜指引方向，道路决定命运。党的二十大的主题，鲜明昭示了我们党在新征程上举什么旗、走什么路、以什么样的精神状态、朝着什么样的目标继续前进，对团结和激励全党全军全国各族人民为夺取中国特色社会主义新胜利而奋斗，具有十分重大的意义。中国特色社会主义是改革开放以来党的全部理论和实践的主题，是党和人民历经千辛万苦、付出巨大代价取得的根本成就。前进道路上，只要高举中国特色社会主义伟大旗帜，始终不渝走中国特色社会主义道路，我们就一定能够不断实现人民对美好生活的向往，不断推进全体人民共同富裕。</p>
        <p>伟大时代孕育伟大理论，伟大理论引领伟大实践。作为马克思主义中国化时代化的最新成果，习近平新时代中国特色社会主义思想以全新视野深化了对共产党执政规律、社会主义建设规律、人类社会发展规律的认识，实现了马克思主义中国化新的飞跃。进入新时代，党和国家事业取得历史性成就、发生历史性变革，根本在于以习近平同志为核心的党中央坚强领导，在于习近平新时代中国特色社会主义思想科学指导。党确立习近平同志党中央的核心、全党的核心地位，确立习近平新时代中国特色社会主义思想的指导地位，反映了全党全军全国各族人民共同心愿，对新时代党和国家事业发展、对推进中华民族伟大复兴历史进程具有决定性意义。</p>
        <p>坚持真理、坚守理想，践行初心、担当使命，不怕牺牲、英勇斗争，对党忠诚、不负人民的伟大建党精神，是中国共产党的精神之源。百年来，伟大建党精神穿越时空、历久弥新，具有重大的时代意义和丰富的实践价值，永远是我们党最可贵的精神财富。从现在起，中国共产党的中心任务就是团结带领全国各族人民全面建成社会主义现代化强国、实现第二个百年奋斗目标，以中国式现代化全面推进中华民族伟大复兴。全党同志务必不忘初心、牢记使命，务必谦虚谨慎、艰苦奋斗，务必敢于斗争、善于斗争，坚定历史自信，增强历史主动，谱写新时代中国特色社会主义更加绚丽的华章。</p>
        <p>新时代画卷锦绣壮丽，新征程篇章气势恢宏。让我们撸起袖子加油干，风雨无阻向前行，一步一个脚印把党的二十大作出的重大决策部署付诸行动、见之于成效，全力跑好属于我们这代人的这一棒，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴作出应有贡献。</p>
        <p style="text-indent: 0; font-weight: 700">声明:转载此文是出于传递更多信息、利于普法之目的。若有来源标注错误或侵犯了您的合法权益，请作者持权属证明与广东东进联系，我们将及时更正、删除，谢谢。</p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build4' })"
            >&lt; 上一条&nbsp;&nbsp;&nbsp;&nbsp;全面理解把握党的二十大... </span
          >
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build2' })"
            >党的二十大主题的深邃意蕴&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build2' })"
            >下一条 &gt; &nbsp;&nbsp;&nbsp;&nbsp;党的二十大主题的深邃意蕴</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news5.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}
.content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
@media screen and (max-width: 768px) {
  .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
}
</style>
